/* eslint-disable  */
__webpack_public_path__ = `${window.resourceBasePath}/`;
